import { Stack } from '@mui/material';
import { FlowFormBlockProviderType } from 'flow-schema';

import { api, isDefined } from 'common';

import { useSchedulingConfigsField } from './hooks/useSchedulingConfigsField';
import { useFlowDefinitionContext } from '../../../../../context';
import { useReactFlowViewContext } from '../../../../context/context';
import { BlockAutocomplete } from '../../../ConfigFields/Autocomplete';
import { SearchableProviderPicker } from '../../../ConfigFields/Autocomplete/SearchableProviderPicker';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

interface SchedulingConfigsProviderBlockProps {
  fieldNamePrefix: string;
}

export function SchedulingConfigsProviderBlock(props: SchedulingConfigsProviderBlockProps) {
  const { fieldNamePrefix } = props;
  const { value: schedulingConfigsValue } = useSchedulingConfigsField(fieldNamePrefix);
  const { value: providerType } = useSelectedNodeField<FlowFormBlockProviderType>(
    `${fieldNamePrefix}.providerType`
  );
  const { isEditable } = useReactFlowViewContext();
  const {
    flowDefinition: { organizationId },
  } = useFlowDefinitionContext();

  if (!isDefined(schedulingConfigsValue)) {
    return null;
  }

  return (
    <Stack gap={1}>
      <BlockSelectField
        fieldName={`${fieldNamePrefix}.providerType`}
        label="Provider Type"
        options={[
          { label: 'Static List', value: FlowFormBlockProviderType.StaticList },
          { label: 'Dynamic List', value: FlowFormBlockProviderType.DynamicList },
          { label: 'Interpolated', value: FlowFormBlockProviderType.Interpolated },
        ]}
      />
      {providerType === FlowFormBlockProviderType.StaticList && (
        <SearchableProviderPicker
          fieldName={`${fieldNamePrefix}.providerIds`}
          label="Providers"
          organizationId={organizationId}
          helperText="Enter provider ID for the appointment."
        />
      )}
      {providerType === FlowFormBlockProviderType.DynamicList && (
        <BlockAutocomplete
          fieldName={`${fieldNamePrefix}.fhirDynamicProviders`}
          label="Providers"
          options={Object.values(api.PrevisitFormTemplateFieldConfig.FhirDynamicProviderKind)}
          multiple
          disabled={!isEditable}
          helperText="Select a dynamic provider from the list"
        />
      )}
      {providerType === FlowFormBlockProviderType.Interpolated && (
        <BlockValueTemplateField
          fieldName={`${fieldNamePrefix}.interpolatedProvider`}
          label="Interpolated Provider"
          helperText="Write the interpolated variable. e.g. {{blockName.data.field}}"
        />
      )}
    </Stack>
  );
}
